var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_11716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 34.2499C18.1269 34.2499 16.5336 33.5932 15.2202 32.2798C13.9067 30.9663 13.25 29.373 13.25 27.5C13.25 26.3269 13.5268 25.2301 14.0803 24.2096C14.2825 23.8369 14.516 23.4954 14.781 23.185C15.6407 22.1779 16.4481 21.0229 16.4481 19.6988V9.30189C16.4481 8.30456 16.7916 7.46325 17.4786 6.77795C18.1656 6.09265 19.0053 5.75 19.9977 5.75C20.9901 5.75 21.8306 6.09265 22.5191 6.77795C23.2076 7.46325 23.5518 8.30456 23.5518 9.30189V19.6988C23.5518 21.0229 24.3592 22.1779 25.2193 23.1846C25.4841 23.4945 25.7176 23.8355 25.9196 24.2075C26.4732 25.2266 26.7499 26.3241 26.7499 27.5C26.7499 29.373 26.0932 30.9663 24.7797 32.2798C23.4663 33.5932 21.873 34.2499 20 34.2499ZM18.3326 17.2077C18.3326 18.1285 19.0791 18.875 20 18.875H20.6153C21.1963 18.875 21.6673 18.404 21.6673 17.8231V17.6048C21.6673 17.1443 21.294 16.7711 20.8336 16.7711H20.6557C20.2936 16.7711 20 16.4775 20 16.1153C20 15.7532 20.2936 15.4596 20.6557 15.4596H20.8336C21.294 15.4596 21.6673 15.0863 21.6673 14.6259V12.9932C21.6673 12.5328 21.294 12.1596 20.8336 12.1596H20.6495C20.2908 12.1596 20 11.8688 20 11.5101C20 11.1513 20.2908 10.8605 20.6495 10.8605H20.8336C21.294 10.8605 21.6673 10.4873 21.6673 10.0269V9.30189C21.6673 8.82949 21.5072 8.4335 21.187 8.11393C20.8669 7.79435 20.4702 7.63456 19.9969 7.63456C19.5236 7.63456 19.1279 7.79435 18.8098 8.11393C18.4917 8.4335 18.3326 8.82949 18.3326 9.30189V17.2077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_11716",
    x: 8.4444,
    y: 0.944401,
    width: 23.1112,
    height: 38.1112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11716",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureSelected);
export default __webpack_public_path__ + "static/media/temperature-selected.d0ceecb2dfbf65d5559b66c8112654a7.svg";
export { ForwardRef as ReactComponent };